import MainStyle from "components/UI/main.module.scss";
import { useState } from 'react';

// This will manage loader visibility globally.
let showLoaderCallback = null;
let hideLoaderCallback = null;

export const useLoader = () => {
  return { showLoader: showLoaderCallback, hideLoader: hideLoaderCallback };
};

// Loader function to be called in the app
export const LoaderCover = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [ logoData, setLogoData ] = useState({logoElement: <></>, loadingMessage: ""});

  // Assign the callbacks globally to control the loader.
  //showLoaderCallback = () => setIsLoading(true);
  showLoaderCallback = ({ logoElement, loadingMessage }) => {
    setLogoData({ logoElement, loadingMessage });
    setIsLoading(true);
  };
  hideLoaderCallback = () => setIsLoading(false);

  if (!isLoading) return null;

  return (
    <div className={[MainStyle.loading_cover].join(" ")}>
        <div className={[MainStyle.loading_cover_dialog].join(" ")}>
            <div className={MainStyle.loading_cover_content}>
                <div className={[MainStyle.loading_cover_header].join(" ")}>
                    <span className={[MainStyle.wait_load_font, MainStyle.fs_6].join(" ")}>
                        {logoData.loadingMessage}
                    </span>
                </div>
                <div className={MainStyle.loading_cover_body}>
                    {logoData.logoElement}
                </div>
            </div>
        </div>
    </div>
  );
};

